export default __webpack_public_path__ + "media/images/manual/joanr/06-a942e9db4a9b10086723bfd93fd3f6a1.png";